import React, {useState, useEffect, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import * as R from 'ramda';
import {Card, CardBody, Row, Col, Button} from 'reactstrap';

import Form from '@/Form';
import Text from '@/Form/Text';
import {blank} from '@/util';
import api from '@/api';
import {SystemConfigCtx} from '@/contexts';

import Separator from '@/views/shared/Separator';
import SuccessScreen from '@/views/ForgetPasswordB2b/SuccessScreen';
import styles from '@/views/ForgetPasswordB2b/index.module.css';

const metaFields = ['errors'];

const ForgetPasswordB2b = () => {
  const [formData, setFormData] = useState({});
  const [flashData, setFlashData] = useState({});
  const {t: tr} = useTranslation('forget_password');
  const {siteCode} = useContext(SystemConfigCtx);

  useEffect(() => {
    const data = {
      loginId: '',
    };

    setFormData(data);
  }, {});

  const handleSubmit = event => {
    event.preventDefault();
    api
      .post('/forget_password_b2b', R.omit(metaFields, formData))
      .then(({data}) => {
        const errors = R.propOr({}, 'errors')(data);
        if (blank(errors)) {
          setFlashData(data.success);
        }
        setFormData(R.assoc('errors', errors));
      });
  };

  if (blank(formData)) {
    return null;
  }

  if (!blank(flashData)) {
    return <SuccessScreen email={R.prop('email')(flashData)} />;
  }

  const colorClass = {
    afs: styles.button_afs,
    ipc: styles.button_ipc,
  };

  if (blank(siteCode)) {
    return null;
  }

  return (
    <Form stateHook={[formData, setFormData]} onSubmit={handleSubmit}>
      <Card>
        <CardBody className={styles.section}>
          <div className='text-center'>
            <h1 className={styles.title}>{tr('title_b2b')}</h1>
            <Separator />
            <h3 className={styles.subtitle}>{tr('sub_title')}</h3>
          </div>
          <Row>
            <Col md={{size: 5, offset: 4}}>
              <h5>{tr('form_head_title_b2b')}</h5>
            </Col>
          </Row>
          <Row form>
            <Col md={{size: 4, offset: 4}}>
              <Text name='loginId' placeholder={tr('login_id_b2b')} required />
            </Col>
          </Row>
          <Row form>
            <Col md={{size: 4, offset: 4}} className='text-center'>
              <Button
                type='submit'
                value='Y'
                className={`${colorClass[siteCode]}`}
                block
              >
                {tr('submit')}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Form>
  );
};

export default ForgetPasswordB2b;
